'use client'

import { useTranslations } from 'next-intl'

import { TTopFAQ } from '@/entities/support'
import { UserType } from '@/entities/user'
import { Link } from '@/shared/i18n'
import { Button, Icon } from '@/shared/ui'
import { TopFAQList } from '@/widgets/faq'

import { Section } from '../section'

type Props = {
  faqs: TTopFAQ[]
  userType: UserType
}

export const FAQ = ({ faqs, userType }: Props) => {
  const t = useTranslations('help_center')

  return (
    <Section.Layout>
      <div className="flex justify-between">
        <div>
          <Section.Title>{t('faq.title')}</Section.Title>
          <Section.Description>{t('faq.description')}</Section.Description>
        </div>
        <div className="w-[608px] space-y-6">
          <TopFAQList faqs={faqs} />
          <Button variant="outline" size="large" fullWidth asChild>
            <Link href={`/${userType}/support/faq`}>
              {t('faq.button.view_all')}
              <Icon name="arrow-right" size={16} />
            </Link>
          </Button>
        </div>
      </div>
    </Section.Layout>
  )
}
